import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import {
  UpdateChannelsRequest,
  UpdateChannelsResponse,
} from '@hud/portal-dtos/channels.dtos';
import { CHANNELS_KEY } from './useChannels';

export default function useUpdateChannelsMutation() {
  const { client } = useClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateChannelsRequest) => {
      const response = await client.put<UpdateChannelsResponse>('/channels/', payload);
      return UpdateChannelsResponse.parse(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CHANNELS_KEY] });
    },
  });
}
